import { ExpenseCategory } from "../../types";

const categoryNames: Record<ExpenseCategory, string> = {
  food: '食品',
  transportation: '交通',
  shopping: '買い物',
  entertainment: '娯楽',
  bills: '水道光熱費',
  other: 'その他',
}

export const categoryName = (category: ExpenseCategory) => {
  return categoryNames[category];
}